import { ArrowRightOutlined } from "@ant-design/icons";
import { Button, ButtonProps } from "antd";
import { FC } from "react";

type AuthButtonProps = Omit<ButtonProps, "type" | "style">;

export const AuthButton: FC<AuthButtonProps> = ({ children, disabled, ...props }) => {
    return (
        <Button
            type="primary"
            htmlType="submit"
            block
            disabled={disabled}
            className="auth-btn"
            style={{
                height: "auto",
                borderRadius: 39,
                fontSize: 16,
                padding: "12px 24px",
                background: disabled
                    ? "linear-gradient(to bottom, #B0B0B0, #8A8A8A)"
                    : "linear-gradient(to bottom, #3D9E9E, #008080)",
                color: "#fff",
                border: "none",
                boxShadow:
                    "inset 0px 1.5px 0px 0px rgba(255,255,255,0.15), inset 0px -1px 0px 0px rgba(0,0,0,0.05), 0px 1px 3px 0px rgba(0,0,0,0.08)",
                fontWeight: 600,
            }}
            {...props}
        >
            {children} <ArrowRightOutlined />
        </Button>
    );
};
